import * as io from "io-ts";
import { PayloadFieldsBaseResolver, PayloadResolver } from "./Content.types";
import { MaybeEmbedFieldResolver } from "./ContentBlocks.types";

export const CoastArticlePayloadFieldsResolver = io.intersection([
  PayloadFieldsBaseResolver,
  io.partial({
    primary_video: MaybeEmbedFieldResolver,
  }),
]);

export const CoastArticlePayloadResolver = io.intersection([
  PayloadResolver,
  io.type({
    fields: CoastArticlePayloadFieldsResolver,
  }),
]);
